import api from './api'

export const emailDashboardService = {
  getSummary: async () => {
    const response = await api.get('/email-dashboard/summary')
    return response.data
  }
}
